export * from './tab-bar.module';
